import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import request from "../../utils/http";
import toaster from "../../utils/toaster";
import { Spinner } from "baseui/spinner";
import ActionHeader from "../../components/ActionHeader";
import { Button } from "baseui/button";
import { FormControl } from "baseui/form-control";
import { Overflow } from "baseui/icon";
import { StatefulPopover } from "baseui/popover";
import ActionBar from "../../components/ActionBar";
import { AiOutlineCheckCircle, AiOutlineLock } from "react-icons/ai";
import { Tabs, Tab } from "baseui/tabs-motion";
import enums from "../../utils/enums";
import { DateTime } from "luxon";
import { Tag } from "baseui/tag";
import CandidateInternalTasks from "./CandidateInternalTasks";
import Prose from "../../components/Prose";
import { StyledTable, StyledHeadCell, StyledBodyCell } from "baseui/table-grid";
import {
	getDateString,
	getDateStringNoZone,
	getRelativeDateString,
} from "../../utils/date";
import CandidateDetail from "../../components/CandidateDetail";
import { FieldGrid } from "./FieldGrid";
import CandidateSites from "../../components/CandidateSites";
import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	ModalButton,
} from "baseui/modal";
import { Input } from "baseui/input";
import { ReadableStreamDefaultController } from "node:stream/web";

const Container = styled.div``;

const Section = styled.div``;

const PlainContainer = styled.div``;
const WhiteContainer = styled.div`
	width: 10rem;
	backgound-color: white;
	display: grid;
`;

const TaskGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	column-gap: 1rem;
	row-gap: 1rem;

	> div {
		border: 1px solid #e0e0e0;
		border-radius: 0.75rem;
		padding: 1rem;
		box-sizing: border-box;

		.dots {
			display: flex;
			.dot {
				width: 0.5rem;
				height: 0.5rem;
				border-radius: 0.5rem;
				background-color: #e0e0e0;
				margin: 1rem 0.2rem 0 0.2rem;
				box-sizing: border-box;
				&.filled {
					background-color: #accc3d;
				}
			}
		}
	}
`;

const StyledTableRow = styled.div`
	display: contents;
`;

const Candidate = () => {
	const navigate = useNavigate();
	const urlParams = useParams() as any;
	const [activeTab, setActiveTab] = React.useState<React.Key>(0);

	const [candidateId, setCandidateId] = useState("");

	const [data, setData] = useState(null as any);
	const [mojStatus, setMojStatus] = useState(null as any);
	const [identityDocumentType, setIdentityDocumentType] = useState(null as any);
	const [residencyStatusType, setResidencyStatusType] = useState(null as any);
	const [employmentAgreements, setEmploymentAgreements] = useState(null as any);

	const [loaded, setLoaded] = useState(false);
	const [isExist, setIsExist] = useState(false);
	const [candidateLoginCreated, setCandidateLoginCreated] = useState(false);
	const [candidatInfo, setCandidateInfo] = useState(null as any);
	const [isLoading, setIsLoading] = useState(false);
	//const [jobOfferMade, setJobOfferMade] = useState(false);

	// const [firstName, setFirstName] = useState("");
	// const [lastName, setLastName] = useState("");
	// const [contactEmail, setContactEmail] = useState("");
	// const [temporaryPassphrase, setTemporaryPassphrase] = useState("");
	// const [onboardingPackUrl, setOnboardingPackUrl] = useState("");

	const display = [
		{
			key: "contact-details",
			label: "Contact Details",
			container: "FieldGrid",
			fields: [
				{
					key: "email",
					label: "Email",
					source: "Candidate.ContactEmail",
					type: "EmailField",
				},
				{
					key: "mobile",
					label: "Mobile",
					source: "Candidate.ContactMobile",
					type: "TextField",
				},
				{
					key: "phone",
					label: "Phone",
					source: "Candidate.ContactPhone",
					type: "TextField",
				},
			],
		},
	];

	const internalDisplay = [
		{
			key: "candidate-internal",
			container: "FieldGrid",
			label: "",
			fields: [
				{
					key: "first-name",
					label: "First Name",
					source: "Candidate.FirstName",
					type: "TextField",
				},
				{
					key: "last-name",
					label: "Last Name",
					source: "Candidate.LastName",
					type: "TextField",
				},
				{
					key: "email",
					label: "Email",
					source: "Candidate.ContactEmail",
					type: "EmailField",
				},
				{
					key: "mobile",
					label: "Mobile",
					source: "Candidate.ContactMobile",
					type: "TextField",
				},
			],
		},
		{
			key: "availability",
			container: "FieldGrid",
			label: "",
			fields: [
				{
					key: "tou",
					label: "Is this a Transfer of undertakings (TOU) candidate?",
					source: "CandidateInternal.IsTOU",
					type: "YesNo",
				},
				{
					key: "available-full-time",
					label: "Available Full Time",
					source: "CandidateInternal.AvailableFullTime",
					type: "YesNo",
				},
				{
					key: "available-part-time",
					label: "Available Part Time",
					source: "CandidateInternal.AvailablePartTime",
					type: "YesNo",
				},
				{
					key: "part-time-confirmation",
					label: "Willing to go ahead even if only part time work is available?",
					source: "CandidateInternal.PartTimeConfirm",
					type: "YesNo",
				},
				{
					key: "working-holiday",
					label: "Is candidate holding a working holiday visa?",
					source: "CandidateInternal.IsWorkingHoliday",
					type: "YesNo",
				},
				{
					key: "previously-worked",
					label: "Previously Worked for PPCS?",
					source: "CandidateInternal.PreviouslyWorked",
					type: "YesNo",
				},
				{
					key: "previously-worked-pin-number",
					label: "Previous Employee Pin Number",
					source: "CandidateInternal.PreviouslyWorkedPinNumber",
					type: "TextField",
				},
				{
					key: "previously-worked-comment",
					label: "Why did the candidate leave?",
					source: "CandidateInternal.PreviouslyWorkedComment",
					type: "TextField",
				},
			],
		},
		{
			key: "replacing",
			container: "FieldGrid",
			label: "",
			fields: [
				{
					key: "who-replacing",
					label: "Who are they replacing?",
					source: "CandidateInternal.ReplacingName",
					type: "TextField",
				},
				{
					key: "replacing-terminated",
					label: "Has that person been terminated?",
					source: "CandidateInternal.ReplacingTerminated",
					type: "YesNo",
				},
			],
		},
		{
			key: "position-details",
			container: "FieldGrid",
			label: "",
			fields: [
				{
					key: "hiring-manager-name",
					label: "Hiring Manager Name",
					source: "CandidateAddendum.HiringManagerName",
					type: "TextField",
				},
				{
					key: "hiring-manager-contact-number",
					label: "Hiring Manager Contact Number",
					source: "CandidateAddendum.HiringManagerContactNumber",
					type: "TextField",
				},
				{
					key: "position",
					label: "Position",
					source: "CandidateAddendum.Position",
					type: "TextField",
				},
				{
					key: "job-description",
					label: "Job Description",
					source: "CandidateAddendum.PositionDescription",
					type: "JobDescription",
				},
				{
					key: "rate",
					label: "Hourly Rate",
					source: "CandidateAddendum.HourlyRate",
					type: "TextField",
					startEnhancer: "$",
				},
				{
					key: "salary",
					label: "Salary",
					source: "CandidateAddendum.Salary",
					type: "TextField",
					startEnhancer: "$",
				},
				{
					key: "rate-reason",
					label: "Custom Hourly Rate Reason",
					source: "CandidateAddendum.ReasonForOtherRate",
					type: "TextField",
				},
				{
					key: "employment-type",
					label: "Employment Type",
					source: "CandidateInternal.EmploymentType",
					enum: "employmentType",
					type: "EnumMap",
				},
				{
					key: "work-region",
					label: "Work Region",
					source: "CandidateInternal.WorkRegion",
					type: "TextField",
				},
				{
					key: "work-department",
					label: "Department",
					source: "CandidateInternal.DepartmentName",
					type: "TextField",
				},
				{
					key: "employment-agreements-offered",
					label: "Employment Agreements Offered",
					type: "EmploymentAgreements",
				},
				{
					key: "approved-by",
					label: "Approved By",
					source: "CandidateInternal.ApprovedByRegionalManager",
					type: "TextField",
				},
				{
					key: "fixed-term-reason",
					label: "Reason for Fixed Term Employment Agreement",
					source: "CandidateAddendum.ReasonForAgreement",
					type: "TextField",
				},
				{
					key: "company-benefit",
					label: "Company Benefits",
					source: "CandidateAddendum.CompanyBenefit",
					type: "TextField",
				},
			],
		},
		{
			key: "school",
			container: "FieldGrid",
			label: "",
			fields: [
				{
					key: "public-school",
					label: "Will the person be working at a school?",
					source: "CandidateInternal.WorkingAtPublicSchool",
					type: "YesNo",
				},
				{
					key: "position",
					label:
						"For the school the person is working at, how many weeks will the supplementary School Cleaner agreement be for?",
					source: "CandidateInternal.WorkingAtPublicSchoolWeeks",
					type: "TextField",
				},
			],
		},
		{
			key: "sites",
			container: "FieldGrid",
			label: "",
			fields: [
				{
					key: "sites-detail",
					label: "Sites",
					type: "CandidateSitesField",
				},
			],
		},
		{
			key: "other",
			container: "FieldGrid",
			label: "",
			fields: [
				{
					key: "days-of-work",
					label: "Days of Work Per Week",
					source: "CandidateAddendum.DaysOfWorkPerWeek",
					type: "TextField",
				},
				{
					key: "hours-of-work",
					label: "Hours Of Work Per Day",
					source: "CandidateAddendum.HoursOfWorkPerDay",
					type: "TextField",
				},
				{
					key: "time-of-work",
					label: "Time of work",
					source: "CandidateAddendum.TimeOfWork",
					type: "TextField",
				},
				{
					key: "based-at",
					label: "Based at",
					source: "CandidateAddendum.BasedAt",
					type: "TextField",
				},
				{
					key: "work-tool",
					label: "Work tool(s)",
					source: "CandidateAddendum.WorkTool",
					type: "TextField",
				},
				{
					key: "10-hours",
					label: "Required in excess of 10 hours per day?",
					soure: "CandidateAddendum.RequiredInExcessOf10HoursPerDay",
					type: "YesNo",
				},
				{
					key: "manager-name",
					label: "Supervisor / Manager Name",
					source: "CandidateAddendum.ManagerName",
					type: "TextField",
				},
				{
					key: "manager-contact-number",
					label: "Supervisor / Manager Contact Number",
					source: "CandidateAddendum.ManagerContactNumber",
					type: "TextField",
				},
				{
					key: "start-date",
					label: "Start Date",
					source: "CandidateAddendum.StartDate",
					type: "DateField",
				},
				{
					key: "fixed-term-end-date",
					label: "Fixed Term End Date",
					source: "CandidateAddendum.FixedTermEndDate",
					type: "DateField",
				},

			],
		},
		{
			key: "additional",
			container: "FieldGrid",
			label: "",
			fields: [
				{
					key: "hepb",
					label: "Will the person be cleaning public toilets where monitoring of Hep B is required?",
					source: "CandidateInternal.HepBMonitoringRequired",
					type: "YesNo",
				},
				{
					key: "driving",
					label: "Will the person be driving a company vehicle?",
					source: "CandidateInternal.DrivingCompanyVehicle",
					type: "YesNo",
				},
				{
					key: "driving-allowance",
					label: "Will the person have travel allowance?",
					source: "CandidateInternal.VehicleAllowancePolicy",
					type: "YesNo",
				},
				{
					key: "waterblast",
					label: "Will this employee be doing Water Blasting on a contract where they will use the machine for most of their shift?",
					source: "CandidateInternal.WaterBlasting",
					type: "YesNo",
				},
			],
		},
		{
			key: "induction",
			container: "FieldGrid",
			label: "",
			fields: [
				{
					key: "induction-ack",
					label:
						"Has this person watched the induction videos?",
					source: "CandidateAgreement.InductionAcknowledgment",
					type: "YesNo",
				},
				{
					key: "induction-done",
					label: "Has this person completed the induction questionnaire?",
					source: "CandidateAgreement.InductionCompleted",
					type: "YesNo",
				},
				{
					key: "handbook-ack",
					label:"Has this person read and understood PPCS Handbook?",
					source: "CandidateAgreement.HandbookAcknowledgment",
					type: "YesNo",
				},
				{
					key: "company-rules-ack",
					label:
						"Has this person read and understood PPCS company rules?",
					source: "CandidateAgreement.CompanyRulesAcknowledgment",
					type: "YesNo",
				},
				{
					key: "media-consent",
					label: "Has this person given consent for photography and media use?",
					source: "CandidateAgreement.MediaConsentTxt",
					type: "TextField",
				},
				{
					key: "birthday-consent",
					label: "Has this person given consent for birthday text and email?",
					source:"CandidateAgreement.BirthdayRecogn",
					type: "TextField",
				},
				{
					key: "tender-use-consent",
					label: "Has this person given consent to use information in Tenders? (N/A if not a Supervisor role)",
					source: "CandidateAgreement.TenderUseConsentTxt",
					type: "TextField",
				},
			],
		},
	];

	// var internalDisplayPILExclude = [
	// 	{
	// 		fields: [
	// 		{
	// 			key: "available-full-time",
	// 			label: "Available Full Time",
	// 			source: "CandidateInternal.AvailableFullTime",
	// 			type: "YesNo",
	// 		},
	// 		{
	// 			key: "available-part-time",
	// 			label: "Available Part Time",
	// 			source: "CandidateInternal.AvailablePartTime",
	// 			type: "YesNo",
	// 		},
	// 		{
	// 			key: "part-time-confirmation",
	// 			label: "Willing to go ahead even if only part time work is available?",
	// 			source: "CandidateInternal.PartTimeConfirm",
	// 			type: "YesNo",
	// 		},
	// 		{
	// 			key: "previously-worked",
	// 			label: "Previously Worked for PPCS?",
	// 			source: "CandidateInternal.PreviouslyWorked",
	// 			type: "YesNo",
	// 		},
	// 		{
	// 			key: "previously-worked-pin-number",
	// 			label: "Previous Employee Pin Number",
	// 			source: "CandidateInternal.PreviouslyWorkedPinNumber",
	// 			type: "TextField",
	// 		},
	// 		{
	// 			key: "previously-worked-comment",
	// 			label: "Why did the candidate leave?",
	// 			source: "CandidateInternal.PreviouslyWorkedComment",
	// 			type: "TextField",
	// 		},
	// 		{
	// 			key: "who-replacing",
	// 			label: "Who are they replacing?",
	// 			source: "CandidateInternal.ReplacingName",
	// 			type: "TextField",
	// 		},
	// 		{
	// 			key: "replacing-terminated",
	// 			label: "Has that person been terminated?",
	// 			source: "CandidateInternal.ReplacingTerminated",
	// 			type: "YesNo",
	// 		},
	// 		{
	// 			key: "public-school",
	// 			label: "Will the person be working at a school?",
	// 			source: "CandidateInternal.WorkingAtPublicSchool",
	// 			type: "YesNo",
	// 		},
	// 		{
	// 			key: "position",
	// 			label:
	// 				"For the school the person is working at, how many weeks will the supplementary School Cleaner agreement be for?",
	// 			source: "CandidateInternal.WorkingAtPublicSchoolWeeks",
	// 			type: "TextField",
	// 		},
	// 		{
	// 			key: "sites-detail",
	// 			label: "Sites",
	// 			type: "CandidateSitesField",
	// 		},
	// 		{
	// 			key: "10-hours",
	// 			label: "Required in excess of 10 hours per day?",
	// 			soure: "CandidateAddendum.RequiredInExcessOf10HoursPerDay",
	// 			type: "YesNo",
	// 		},
	// 		{
	// 			key: "hepb",
	// 			label:
	// 				"Will the person be cleaning public toilets where monitoring of Hep B is required?",
	// 			source: "CandidateInternal.HepBMonitoringRequired",
	// 			type: "YesNo",
	// 		},
	// 		{
	// 			key: "driving",
	// 			label: "Will the person be driving a company vehicle?",
	// 			source: "CandidateInternal.DrivingCompanyVehicle",
	// 			type: "YesNo",
	// 		},
	// 		{
	// 			key: "kerbside",
	// 			label:
	// 				"Will the person work on a contract where Kerbside Collection Team Leader (KCTL) or TCL1 is a requirement?",
	// 			source: "CandidateInternal.KerbsideCollection",
	// 			type: "YesNo",
	// 		},
	// 		{
	// 			key: "waterblast",
	// 			label: "Will this employee be doing Water Blasting on a contract where they will use the machine for most of their shift?",
	// 			source: "CandidateInternal.WaterBlasting",
	// 			type: "YesNo",
	// 		},
	// 	]
	// }
	// ];

	var detailData = "";
	const TextField = (props: any) => {
		detailData = resolveCandidateDetail(props.source);
		return (
			<div>
				<FormControl label={props.label}>
					<>
						{props.startEnhancer && <>{props.startEnhancer}</>}
						{detailData ? detailData : "-"}
					</>
				</FormControl>
			</div>
		);
	};

	const EmailField = (props: any) => {
		return (
			<div>
				<FormControl label={props.label}>
					<>
						<a href={`mailto:${resolveCandidateDetail(props.source)}`}>
							{resolveCandidateDetail(props.source)}
						</a>
					</>
				</FormControl>
			</div>
		);
	};

	const YesNo = (props: any) => {
		return (
			<div>
				<FormControl label={props.label}>
					<>{resolveCandidateDetail(props.source) ? "Yes" : "No"}</>
				</FormControl>
			</div>
		);
	};

	const EnumMap = (props: any) => {
		const thisValue = (enums as any)[props.enum].find(
			(item: any) => item.value == resolveCandidateDetail(props.source)
		)?.label;

		return (
			<div>
				<FormControl label={props.label}>
					<>{thisValue}</>
				</FormControl>
			</div>
		);
	};

	const EmploymentAgreements = (props: any) => {
		return (
			<div>
				<FormControl label={props.label}>
					<ul>
						{employmentAgreements &&
							resolveCandidateDetail(
								"CandidateInternal.AvailableEmploymentAgreements"
							) &&
							resolveCandidateDetail(
								"CandidateInternal.AvailableEmploymentAgreements"
							).map((item: string) => {
								const thisEa = employmentAgreements.find(
									(ea: any) => ea.identifier == item
								);
								return (
									<li>
										{thisEa.name}
										{thisEa.notes && (
											<>
												<br />
												<small>{thisEa.notes}</small>
											</>
										)}
									</li>
								);
							})}
					</ul>
				</FormControl>
			</div>
		);
	};

	const CandidateSitesField = (props: any) => {
		return (
			<div className="full-row">
				<CandidateSites candidateSites={data.sites} />
			</div>
		);
	};

	const DateField = (props: any) => {
		const thisValue = resolveCandidateDetail(props.source)
			? getDateStringNoZone(resolveCandidateDetail(props.source))
			: "";

		return (
			<div>
				<FormControl label={props.label}>
					<>{thisValue}</>
				</FormControl>
			</div>
		);
	};

	const JobDescription = (props: any) => {
		const thisValue = resolveCandidateDetail(props.source);

		return (
			<div>
				<FormControl label={props.label}>
					<>{thisValue?.name}</>
				</FormControl>
			</div>
		);
	};

	const displayFieldType = {
		TextField,
		EmailField,
		YesNo,
		EnumMap,
		EmploymentAgreements,
		CandidateSitesField,
		DateField,
		JobDescription,
	} as Record<string, any>;

	const displayContainerType = {
		FieldGrid,
		PlainContainer,
	} as Record<string, any>;

	const resolveCandidateDetail = (key: string) => {
		return data.fields[key];
	};

	const updateUrlParams = async () => {
		setCandidateId(urlParams.candidateId);
	};

	const getCandidate = async () => {
		let result = await request(
			"GET",
			`/api/admin/candidate/${candidateId}`,
			null,
			true,
			false
		);
		if (result.success && result.data?.candidateId) {
			setData(result.data);

			setMojStatus(
				enums.candidateMojStatus.find(
					(item: any) =>
						item.value === result.data.fields["CandidateMOJ.Status"]
				)
			);

			setIdentityDocumentType(
				enums.candidateIdentityDocumentType.find(
					(item: any) =>
						item.value === result.data.fields["CandidateIdentityDocument.Type"]
				)
			);

			setResidencyStatusType(
				enums.candidateResidencyStatus.find(
					(item: any) =>
						item.value ===
						result.data.fields["Candidate.CandidateResidencyStatus"]
				)
			);

			//setJobOfferMade(result.data.jobOfferMade);

			setLoaded(true);
		} else {
			toaster.error("Unable to access candidate");
		}
	};

	const getEmploymentAgreements = async () => {
		let result = await request(
			"GET",
			"/api/admin/utility/candidate/employment-agreements",
			null,
			true,
			false
		);
		if (result.success) {
			setEmploymentAgreements(result.data.items);
		} else {
			toaster.error("Unable to access employment agreements");
		}
	};

	const loginAsCandidate = async () => {
		let result = await request(
			"POST",
			`/api/admin/candidate-action/login-as/${candidateId}`,
			null,
			true,
			false
		);
		if (result.success) {
			window.open(result.data.loginUrl);
		}
	};

	const resetPassword = async () => {
		let result = await request(
			"POST",
			`/api/admin/candidate-action/reset-password/${candidateId}`,
			null,
			true,
			false
		);
		if (result.success) {
			toaster.success("Password reset and emailed to candidate");
		}
	};

	const taskSetUnlock = async (taskName:string, tLocked:boolean, tCompleted:boolean) => {
		if(!tLocked && tCompleted)
		{
			const sendRequest = window.confirm("Do you want to unlock this section for the candidate to edit?");
			if(sendRequest)
			{
				const result = await request(
					"POST",
					`/api/admin/candidate-action/section-uncomplete/${candidateId}?tName=`+taskName,
					null,
					true,
					false
				);
				if (result.success) {
					toaster.success("Section is open for edit. Refreshing page now");
					setTimeout(() => {
						pageRefresh();
						}, 2000);
				}						
			}
		}
	};

	const createCandidateLogin = async () => {
				setIsLoading(true);
				const result = await request(
					"POST",
					`/api/admin/candidate-action/create-login/${candidateId}`,
					null,
					true,
					false
				);
				if (result.success) {
					// toaster.success("Candidate login has been created.");
					setCandidateInfo(result.data);
					setCandidateLoginCreated(true);
					// setTimeout(() => {
					// 	pageRefresh();
					// 	}, 5000);
				}					
	};

	const pageRefresh = () => {window.location.reload();}
	
	const isCandidateExist = async () => {
		const result = await request(
			"POST",
			`/api/admin/candidate-action/candidate-exist-check/${candidateId}`,
			null,
			true,
			false
		);
		return result.success
	};

	useEffect(() => {
		if (candidateId != "") {
			getCandidate();
			getEmploymentAgreements();

			isCandidateExist().then(result => {
			setIsExist(result);
			}).catch(error => {
			console.error(error);
			});
		}
	}, [candidateId]);

	useEffect(() => {
		updateUrlParams();
	}, [urlParams, updateUrlParams]);
	
	return (
		<Container>
			{!loaded && (
				<div>
					<Spinner />
				</div>
			)}
			{loaded && data && (
				<>
					<ActionHeader>
						<h1>
							{data.fields["Candidate.CandidateType"]}{": "}
							{data.fields["Candidate.FirstName"]}{" "}
							{data.fields["Candidate.LastName"]}
						</h1>
						<ActionBar>
							<StatefulPopover
								content={
									<WhiteContainer>
										{!isExist && 
											<Button
												key="view"
												kind="tertiary"
												onClick={() => {
													data.fields["Candidate.CandidateType"] == "PPCS"?
													navigate(`/candidate-edit/${candidateId}`):
													data.fields["Candidate.CandidateType"] == "PIL"?
													navigate(`/candidate-pil-edit/${candidateId}`):
													navigate(`/candidate/${candidateId}`)
												}}
											>
												Edit Details
											</Button>										
										}
										<Button
											key="reject"
											kind="tertiary"
											onClick={() => {
												navigate(`/candidate-reallocate/${candidateId}`);
											}}
										>
											Reallocate
										</Button>
										<Button
											key="view"
											kind="tertiary"
											onClick={() => {
												navigate(`/candidate-moj/${candidateId}`);
											}}
										>
											View MOJ
										</Button>
										<Button
											key="view"
											kind="tertiary"
											onClick={() => {
												navigate(`/candidate-offer/${candidateId}`);
											}}
										>
											Manage Job Offer
										</Button>
										
										{isExist ?
											(<>
												<Button
														key="view"
														kind="tertiary"
														onClick={loginAsCandidate}
													>
														Login as Candidate
													</Button><Button key="view" kind="tertiary" onClick={resetPassword}>
															Reset Password
												</Button>
											</>								
											)
											:
											(
												isLoading?
												<div >
													<Spinner style={{position: "relative",
													left: "60px",
													top: "-5px"}}/>
												</div>
												:							
												<Button key="view" kind="tertiary" 	onClick={createCandidateLogin}>
													Create Login
												</Button>
											)
										}
										
									{candidateLoginCreated && (
										<Modal
											closeable={false}
											isOpen={candidateLoginCreated}
											animate
											autoFocus
											role="dialog"
										>
											<ModalHeader>
											{candidatInfo.firstName} {candidatInfo.lastName} Created
											</ModalHeader>
											<ModalBody>
												A temporary password has been set. This will last for seven days.
												When you close this window, these details will be lost
												<br />
												<br />
												Username: <Input value={candidatInfo.contactEmail} /> <br />
												Password:{" "}
												<Input type="password" value={candidatInfo.temporaryPassphrase} />
												<br />
												<br />
												<a href={candidatInfo.onboardingPackUrl} target="_blank">
													Download Onboarding Pack for Printing
												</a>
											</ModalBody>
											<ModalFooter>
												<ModalButton onClick={pageRefresh}>Okay</ModalButton>
											</ModalFooter>
										</Modal>
									)}
									</WhiteContainer>
								}
								placement={"bottomRight"}
							>
								<Button kind="secondary">
									<Overflow />
								</Button>
							</StatefulPopover>
						</ActionBar>
					</ActionHeader>

					<Tabs
						activeKey={activeTab}
						onChange={({ activeKey }) => setActiveTab(activeKey)}
					>
						<Tab title="Summary">
							{data.fields["Candidate.Archived"] === true && (
								<>
									<Section>
										<h2>
											Archived:{" "}
											{data.fields["Candidate.ArchivedReason.ToString"]} by{" "}
											{data.fields["Candidate.ArchivedBy"]}
										</h2>
										<Prose>
											<p>{data.fields["Candidate.ArchivedNote"]}</p>
											<p>
												<em>
													{DateTime.fromISO(
														data.fields["Candidate.ArchivedDate"],
														{
															zone: "utc",
														}
													)
														.setZone("Pacific/Auckland")
														.toLocaleString(DateTime.DATETIME_MED)}{" "}
													<em>
														(
														{DateTime.fromISO(
															data.fields["Candidate.ArchivedDate"],
															{
																zone: "utc",
															}
														)
															.setZone("Pacific/Auckland")
															.toRelative()}
														)
													</em>
												</em>
											</p>
										</Prose>
									</Section>
									<hr />
								</>
							)}

							<Section>
								<TaskGrid>
									{data.taskSets.map((taskSet: any) => {
										return (
											<div id={taskSet.name} //can be taskSet.code
												onClick={() => {	
													taskSetUnlock(taskSet.name,taskSet.locked,taskSet.completed)
													}
												}
												>
												
												<strong>
													{taskSet.name}{" "}
													{taskSet.completed && (
														<>
															<AiOutlineCheckCircle />
														</>
													)}{" "}
													{taskSet.locked && (
														<>
															<AiOutlineLock />
														</>
													)}
												</strong>
												<div className="dots">
													{(() => {
														let dots = [];
														for (let i = 0; i < taskSet.steps; i++) {
															dots.push(
																<div
																	className={
																		i < taskSet.stepsCompleted
																			? "dot filled"
																			: "dot"
																	}
																></div>
															);
														}
														return dots;
													})()}
												</div>
											</div>
										);
									})}
								</TaskGrid>
							</Section>

							<hr />
							{display.map((section) => {
								if (section != null) {
									const Container = displayContainerType[section.container];

									return (
										<>
											<Section key={section.key}>
												{section.label && <h2>{section.label}</h2>}
												<Container>
													{section.fields.map((field) => {
														const Field = displayFieldType[field.type];
														return <Field {...field} />;
													})}
												</Container>
											</Section>
											<hr />
										</>
									);
								}
							})}
						</Tab>

						<Tab title="Internal Detail">
							<Section key="internal-detail">
								{internalDisplay.map((section) => {
									const Container = displayContainerType[section.container];

									return (
										<> 
											<Section key={section.key}>
												{section.label && <h2>{section.label}</h2>}
												<Container>
													{section.fields.map((field) => {
														const Field = displayFieldType[field.type];
														return <Field {...field} />;
													})}
												</Container>
											</Section>
											<hr />
										</>
									);
								})}
							</Section>
						</Tab>

						<Tab title="Candidate Tasks">
							<Section key="candidate-tasks">
								<CandidateDetail candidateId={candidateId} />
							</Section>
						</Tab>

						<Tab title="Internal Tasks">
							<Section key="moj">
								<h2>Ministry of Justice Check</h2>
								<p>
									{mojStatus && (
										<>
											<Tag
												closeable={false}
												kind={mojStatus.kind}
												variant={mojStatus.variant}
												overrides={{ Text: { style: { maxWidth: "" } } }}
											>
												{mojStatus.label}
											</Tag>{" "}
											at{" "}
											{DateTime.fromISO(
												data.fields["CandidateMOJ.StatusDate"],
												{
													zone: "utc",
												}
											)
												.setZone("Pacific/Auckland")
												.toLocaleString(DateTime.DATETIME_MED)}{" "}
											<em>
												(
												{DateTime.fromISO(
													data.fields["CandidateMOJ.StatusDate"],
													{
														zone: "utc",
													}
												)
													.setZone("Pacific/Auckland")
													.toRelative()}
												)
											</em>
										</>
									)}
								</p>
								<Button
									kind="secondary"
									onClick={() => {
										navigate(`/candidate-moj/${candidateId}`);
									}}
								>
									View MOJ detail
								</Button>
							</Section>
							<hr />
							<Section key="other">
								<h2>Internal Tasks</h2>
								<CandidateInternalTasks candidateId={candidateId} />
							</Section>
							<hr />
							<Section key="complete">
								<h2>Complete Application</h2>
								<p>
									If all data is complete, move on to the final completion
									steps.
								</p>
								<Button
									kind="secondary"
									onClick={() => {
										navigate(`/candidate-complete/${candidateId}`);
									}}
								>
									Complete application
								</Button>
							</Section>
							<hr />
							<Section key="complete">
								<h2>Cancel and Close Application</h2>
								<p>Reject an application and lock the candidate's account</p>
								<Button
									kind="secondary"
									onClick={() => {
										navigate(`/candidate-cancel/${candidateId}`);
									}}
								>
									Cancel application
								</Button>
							</Section>
						</Tab>
						<Tab title="Notes">
							<Section>
								<>
									<StyledTable
										role="grid"
										$gridTemplateColumns={"3fr 0.5fr 1fr 1fr"}
									>
										<StyledTableRow role="row">
											<StyledHeadCell>Note</StyledHeadCell>
											<StyledHeadCell>Topic</StyledHeadCell>
											<StyledHeadCell>Name</StyledHeadCell>
											<StyledHeadCell>Date</StyledHeadCell>
										</StyledTableRow>
										{data?.notes &&
											data?.notes.map((note: any, i: number) => {
												const striped = i % 2 === 0;

												return (
													<StyledTableRow role="row">
														<StyledBodyCell $striped={striped}>
															{note.note.indexOf("\n") > -1 ? (
																<>
																	{note.note
																		.split("\n")
																		.map((noteLine: string) => {
																			return <p>{noteLine}</p>;
																		})}
																</>
															) : (
																<p>{note.note}</p>
															)}
														</StyledBodyCell>
														<StyledBodyCell $striped={striped}>
															<p>{note.topic}</p>
														</StyledBodyCell>
														<StyledBodyCell $striped={striped}>
															<p>{note.createdBy}</p>
														</StyledBodyCell>
														<StyledBodyCell $striped={striped}>
															<p>
																{getDateString(note.createdUtc)} <br />
																<em>
																	({getRelativeDateString(note.createdUtc)})
																</em>
															</p>
														</StyledBodyCell>
													</StyledTableRow>
												);
											})}
									</StyledTable>
								</>
							</Section>
						</Tab>
						<Tab title={"Files"}>
							<Section>
								<StyledTable
									role="grid"
									$gridTemplateColumns={"1fr 1fr 1fr 1fr 0.5fr"}
								>
									<StyledTableRow role="row">
										<StyledHeadCell>File Type</StyledHeadCell>
										<StyledHeadCell>Name</StyledHeadCell>
										<StyledHeadCell>Uploaded</StyledHeadCell>
										<StyledHeadCell>Uploaded By</StyledHeadCell>
										<StyledHeadCell>Download</StyledHeadCell>
									</StyledTableRow>
									{data?.files &&
										data?.files.map((file: any, i: number) => {
											const striped = i % 2 === 0;

											return (
												<StyledTableRow role="row">
													<StyledBodyCell $striped={striped}>
														<p>{file.fileType}</p>
													</StyledBodyCell>
													<StyledBodyCell $striped={striped}>
														<p>{file.fileName}</p>
													</StyledBodyCell>
													<StyledBodyCell $striped={striped}>
														<p>
															{DateTime.fromISO(file.uploadedUtc, {
																zone: "utc",
															})
																.setZone("Pacific/Auckland")
																.toLocaleString(DateTime.DATETIME_MED)}
														</p>
													</StyledBodyCell>
													<StyledBodyCell $striped={striped}>
														<p>{file.uploadedBy}</p>
													</StyledBodyCell>
													<StyledBodyCell $striped={striped}>
														<p>
															<a href={file.downloadLink} target="_blank">
																Download
															</a>
														</p>
													</StyledBodyCell>
												</StyledTableRow>
											);
										})}
								</StyledTable>
							</Section>
						</Tab>
					</Tabs>
				</>
			)}
		</Container>
	);
};
export default Candidate;
